module.exports = __webpack_public_path__ + "static/Amanda_Blanc-bde2c3421728fddbf03f4924c77bb4c9.webp";